export default "__VITE_PUBLIC_ASSET__09738745__"